import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import ApiService from "./common/api.service";
// import MockService from "./common/mock/mock.service";
// import { VERIFY_AUTH } from "./store/auth.module";

import JwtService from "@/common/jwt.service";
import { postRequest } from "@/api/request.js";
import { hydrateAdminSession, createMfaRouteGuard, acceptIncomingAdminToken } from "@/common/admin-session";
Vue.config.productionTip = false;
import "@/mixins/permissionMixin";

// Global 3rd party plugins
import "bootstrap";
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";
import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

// Vue 3rd party plugins
import i18n from "./common/plugins/vue-i18n";
import vuetify from "./common/plugins/vuetify";
import "./common/plugins/bootstrap-vue";
import "./common/plugins/perfect-scrollbar";
import "./common/plugins/highlight-js";
import "@babel/polyfill";
import "@mdi/font/css/materialdesignicons.css";
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelListSelect } from 'vue-search-select'
Vue.component("ModelListSelect", ModelListSelect);
// API service init
// ApiService.init();

// Remove this to disable mock API
// MockService.init();

// Recheck the server policy before entering a protected route, including
// existing sessions and direct links to business pages.
router.beforeEach(createMfaRouteGuard({
  request: postRequest,
  getToken: () => JwtService.getToken(),
  saveTfaState: value => JwtService.saveTfaState(value),
  hydrateIfNeeded: token => localStorage.getItem("domainswithoutmx") === null
    ? hydrateAdminSession(token) : Promise.resolve(),
}));

// Owner/Super handoffs use the API's actor-authorized session policy.
const locationUrl = new URL(window.location.href);
const hashQuery = new URLSearchParams((locationUrl.hash.split("?")[1] || ""));
const incomingToken = locationUrl.searchParams.get("token") || hashQuery.get("token");
if (incomingToken && /^[a-f0-9]{32}$/i.test(incomingToken)) {
  acceptIncomingAdminToken(incomingToken)
    .then(destination => router.replace(destination))
    .catch(() => router.replace("/login"));
}

// Scroll page to top on every route change
setTimeout(() => {
  window.scrollTo(0, 0);
}, 100);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
